import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";

// Element UI
import ElementUI from "element-ui";
import "element-ui/lib/theme-chalk/index.css";

// 全局样式
import "@/styles/index.scss";

// 工具库
import * as utils from "@/utils";

// ECharts 配置
import { use } from "echarts/core";
import { CanvasRenderer } from "echarts/renderers";
import { LineChart, BarChart, PieChart } from "echarts/charts";
import {
  TitleComponent,
  TooltipComponent,
  LegendComponent,
  GridComponent,
} from "echarts/components";
import VChart from "vue-echarts";

// 注册 ECharts 组件
use([
  CanvasRenderer,
  LineChart,
  BarChart,
  PieChart,
  TitleComponent,
  TooltipComponent,
  LegendComponent,
  GridComponent,
]);

// 进度条
import NProgress from "nprogress";
import "nprogress/nprogress.css";

// 配置 NProgress
NProgress.configure({ showSpinner: false });

Vue.config.productionTip = false;

// 使用 Element UI
Vue.use(ElementUI);

// 注册 VChart 组件
Vue.component("VChart", VChart);

// 全局工具方法
Vue.prototype.$utils = utils;

// 全局错误处理
Vue.config.errorHandler = (err, vm, info) => {
  console.error("全局错误:", err, info);
  Vue.prototype.$message.error("系统出现错误，请稍后重试");
};

new Vue({
  router,
  store,
  render: h => h(App),
}).$mount("#app");
